import { render, staticRenderFns } from "./thongtinnhanhoadon.vue?vue&type=template&id=6cd85f09&scoped=true"
import script from "./thongtinnhanhoadon.vue?vue&type=script&lang=js"
export * from "./thongtinnhanhoadon.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/style-review.css?vue&type=style&index=0&id=6cd85f09&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd85f09",
  null
  
)

export default component.exports